<template>
    <div class="giftcard-redemption-component">
        <div class="row justify-content-center">

            <div class="col-md-6 col">
                <b-alert variant="danger" :show="hasError" class="mb-2">{{ error }}</b-alert>
                <b-alert variant="success" :show="isSuccess" class="mb-2">{{ successMsg }}</b-alert>

                <div class="input-group mb-2">
                    <input type="text" class="form-control" placeholder="Gift card number" required v-model="userToken">
                    <button class="btn btn-primary d-none d-sm-block" type="button" @click="handleCode">Redeem</button>
                </div>
                <div class="text-center">
                    <button class="btn btn-primary d-inline-block d-sm-none" type="button" @click="handleCode">Redeem</button>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>    
    export default {
        data() {
            return {
                isBusy: false,
                error: false,
                hasError: false,
                isSuccess: false,
                successMsg: '',
                defaultBtnText: 'Redeem',
                btnText: 'Redeem',
                userToken: '',
            }
        },

        mounted() {
            this.btnText = this.defaultBtnText;
        },

        methods: {
            handleCode() {
                this.isBusy = true;
                this.btnText = 'Please wait...';
                this.hasError = false;

                axios.post('/api/giftcards/check', {
                    'token': this.userToken,
                })
                    .then((response) => {
                        if(response.data.success) {
                            // Success
                            this.successMsg = response.data.successMsg;
                            this.isSuccess = true;
                        }

                        if(response.data.error) {
                            this.hasError = true;
                            this.error = response.data.error;
                            this.isBusy = false;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.hasError = true;
                        this.error = 'An unexpected error occured.';
                        this.isBusy = false;
                    });
            },
        }
    }
</script>